import { render, staticRenderFns } from "./productInfoShow.vue?vue&type=template&id=0f0788a8&scoped=true&"
import script from "./productInfoShow.vue?vue&type=script&lang=js&"
export * from "./productInfoShow.vue?vue&type=script&lang=js&"
import style0 from "./productInfoShow.vue?vue&type=style&index=0&id=0f0788a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0788a8",
  null
  
)

export default component.exports